import type { M365Acquisition } from "owa-graph-schema";

/**
 * Returns true when the acquisition is a stub synthesized locally from the user's pinned app
 * bar tiles rather than data returned by the service.
 *
 * These stubs exist so a pinned tile can still be rendered before MOS3 responds, so they carry
 * display data only: no content URL, no permissions, and an empty eligibility. Any caller that
 * needs the real definition, or that records what the service reported about the user, must
 * treat a stub as "not known yet" instead of as an answer.
 */
export function isUserPinnedStubAcquisition(acquisition: M365Acquisition | undefined): boolean {
    return acquisition?.titleDefinition.ingestionSource === "UserPinnedAcquisition";
}
